import * as React from 'react';
import { App } from './App';
import { IHomepageStore } from './models/content.interfaces';
import * as browserContentProvider from './services/browserContentProvider';

const store: IHomepageStore = browserContentProvider.get();

export const Root = () => {
  return <App store={store} />;
};

export default Root;
